/* eslint-disable max-classes-per-file */

export class Location {
    public static readonly ZRH: string = 'ZRH';
}
export class PersonContractType {
    public static readonly Freelance: string = 'freelance';
}

export class Logs {
    public static readonly MaxSizeInMbToDownload: number = 10;
}

export class PersonInfo {
    public static readonly Age: number = 60;
}

export class MouseButtons {
    public static readonly Left: number = 0;
    public static readonly Wheel: number = 1;
    public static readonly Right: number = 2;
}

export class CheckerTraineeFunctionName {
    public static readonly CL: string = 'CL';
    public static readonly SafetyPilot: string = 'Safety Pilot';
    public static readonly EisCrew: string = 'EIS-Crew';
}

export class ChangeLogStatuses {
    public static readonly confirmed: string = 'Confirmed';
    public static readonly notConfirmed: string = 'NotConfirmed';
}

export class Status {
    public static readonly success: string = 'Success';
    public static readonly warning: string = 'Warning';
    public static readonly fail: string = 'Fail';
}

export class Security {
    public static readonly FreezePeriodError: string = 'Only Administrator or Support can do changes in salary payment period.';
}

export class Actions {
    public static readonly ADD: string = 'Add';
    public static readonly UPDATE: string = 'Update';
    public static readonly DELETE: string = 'Delete';
}

export class AircraftTypeActivityExperience {
    public static readonly ConsecutiveLength: number = 120;
    public static readonly ConsecutiveBlockHours: number = 100;
    public static readonly ConsecutiveSectorsCount: number = 10;
    public static readonly GeneralBlockHours: number = 150;
    public static readonly GeneralSectorsCount: number = 20;
}

export class ParameterType {
    public static readonly DateTime: string = 'DateTime';
    public static readonly Date: string = 'Date';
    public static readonly Boolean: string = 'Boolean';
    public static readonly MultiLine: string = 'Multiline';
    public static readonly SingleLine: string = 'String';
    public static readonly Integer: string = 'Integer';
    public static readonly Enum: string = 'Enum';
}

export class AircraftTypeRecencyLandingType {
    public static readonly SimpleLanding: string = 'SimpleLanding';
    public static readonly SIM: string = 'SIM';
    public static readonly CustomLanding: string = 'CustomLanding';
    public static readonly Training: string = 'Training';
}

export class FlightType {
    public static readonly Outbound: string = 'Outbound';
    public static readonly Inbound: string = 'Inbound';
}

export enum HttpStatusCode {
    BadRequest = 400,
    Conflict = 409
}

export enum DifferenceStateEnum {
    empty = 0,
    notAvailable = 1,
    availableFull = 2,
    available15 = 3,
    available30 = 4
}

export enum LastUpdatedFilter {
    FunctionId,
    PartialLoadType,
    FunctionFromDate,
    TypeRatingFilters,
    QualificationIds,
    InstructorFilters,
    ContractTypes,
    ContractFlagTypes,
    ReferenceDate,
    MonthlyTypes,
    ReleaseFilterTypes,
    TopPersonIds,
    Search,
    Sort,
    Order,
    SortBaseDate,
    IsSortFrozen,
    PersonsFilterMode,
    DutyFilter
}

export class MessageQueueItemDirectionType {
    public static readonly In: string = 'In';
    public static readonly Out: string = 'Out';
    public static readonly DeadletterToInbox: string = 'DeadletterToInbox';
}

export class PageTitles {
    public static readonly Home: string = 'Home';
    public static readonly HealthBoard: string = 'Health Board';
    public static readonly JobList: string = 'Job List';
    public static readonly Maintenance: string = 'Maintenance';
    public static readonly Configs: string = 'Configs';
    public static readonly CrewApi: string = 'Crew API';
    public static readonly CrewPortal: string = 'Crew Portal';
    public static readonly HotelManagementDaily: string = 'Hotel Management Daily';
    public static readonly HotelManagementMonthly: string = 'Hotel Management Monthly';
    public static readonly RotationTool: string = 'Rotation Tool';
    public static readonly VacManagement: string = 'Vac Management';
    public static readonly RequestTool: string = 'Request Tool';
    public static readonly RequestCapacityTool: string = 'Request Capacity Tool';
    public static readonly PersonReport: string = 'Person Report';
    public static readonly RecurrentTrainingReport: string = 'Recurrent Training Report';
    public static readonly StandbyReport: string = 'Standby Report';
    public static readonly PlannedTrainingsReport: string = 'Planned Trainings Report';
    public static readonly FncRecencyReport: string = 'Fnc Recency Report';
    public static readonly AreaRouteCompetenceReport: string = 'Area Route Competence Report';
    public static readonly SectorsReport: string = 'Sectors Report';
    public static readonly CrewDutyListReport: string = 'Crew Duty List Report';
    public static readonly RosterReport: string = 'Roster Report';
    public static readonly CommentReport: string = 'Comment Report';
    public static readonly OffDaysReport: string = 'Off Days Report';
    public static readonly HomeStudy: string = 'Home Study';
    public static readonly UrgentDutyReport: string = 'Urgent Duty Report';
    public static readonly AircraftTypeRecencyCockpitReport: string = 'Aircraft Type Recency Cockpit Report';
    public static readonly AircraftTypeRecencyCabinReport: string = 'Aircraft Type Recency Cabin Report';
    public static readonly DooxReport: string = 'Doox Report';
    public static readonly ExperienceReport: string = 'Experience Report';
    public static readonly SimulatorLicenseStatusReport: string = 'Simulator License Status Report';
    public static readonly ErrorReport: string = 'Error Report';
    public static readonly PersonVacYearDetails: string = 'Person Vac Year Details';
    public static readonly TzvReport: string = 'Tzv Report';
    public static readonly ChangeLog: string = 'Change Log';
    public static readonly JeppesenTool: string = 'Jeppesen Tool';
    public static readonly AeroPersInterface: string = 'Aero Pers Interface';
    public static readonly LicenseManagement: string = 'License Management';
    public static readonly BlockDaysManagement: string = 'Block Days Management';
    public static readonly RequestTimeline: string = 'Request Timeline';
    public static readonly NotFound: string = 'Not Found';
}

export class FreelanceTool {
    public static readonly CockpitJulOctMaxReduction: number = 16;
}
